// theme.ts
import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    toReturn: { main: string; contrastText: string };
    Standard: { main: string; contrastText: string };
    TWO_WAY_DELIVERY: { main: string; contrastText: string };
    OKM: { main: string; contrastText: string };
  }
  interface PaletteOptions {
    toReturn?: { main: string; contrastText: string };
    Standard?: { main: string; contrastText: string };
    TWO_WAY_DELIVERY?: { main: string; contrastText: string };
    OKM?: { main: string; contrastText: string };
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    toReturn: true;
    Standard: true;
    TWO_WAY_DELIVERY: true;
    OKM: true;
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
  },
  palette: {
    background: {
      default: "#f9f5f5ff",
    },
    primary: {
      main: "#00244f",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ff5c8d",
      contrastText: "#fff",
    },
    toReturn: {
      main: "#D4A81B",
      contrastText: "#fff",
    },
    Standard: {
      main: "#1A5DA6",
      contrastText: "#fff",
    },
    TWO_WAY_DELIVERY: {
      main: "#8A4FCE",
      contrastText: "#fff",
    },
    OKM: {
      main: "#3DA58A",
      contrastText: "#fff",
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: '"Montserrat", "sans-serif"',
          fontWeight: 400,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // backgroundColor: "oklch(92.9% 0.013 255.508)",
          // borderRadius: 8,
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          lineHeight: 1.5,
          letterSpacing: "0.04rem",
          fontSize: "0.8rem",
          "&:focus-visible": {
            outline: "2px solid #00244f",
            outlineOffset: "2px",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          "&:focus-visible": {
            outline: "2px solid #00244f",
            outlineOffset: "2px",
          },
        },
      },
    },
  },
});
